__turbopack_context__.v({
  "root": "LiquidMetal-module__aa-yPW__root",
});
